module.exports = __webpack_public_path__ + "img/line.240d61eb.png";